import LoadingSpinner from "../UI/LoadingSpinner";

const ReasonForContact = (props) => {

    const handleCategorySelection = (supportName) => {
        if (props.issueReason === supportName) {
            props.setIssueReason('');
            props.setIsReasonOptionSelected(false);
        } else {
            props.setIssueReason(supportName);
            props.setIsReasonOptionSelected(true);
            props.nextToFormSubmission()
        }
    }

    return (
        <div className="stepsContainer max-w-full lg:max-w-[70%] mx-auto">
            {props.isLoading && (
                <div className="parentDisable">
                    <LoadingSpinner />
                </div>
            )}
            <div className="mt-7 sm:mt-9">
                <div className="supportQueries mt-6 sm:mt-8 text-center">
                    <h3 className="text-lg leading-6 sm:text-2xl sm:leading-8 font-medium">2.Why are you contacting us?  </h3>
                    {props.supportAreas &&<p className="text-base leading-5 sm:text-lg sm:leading-8 font-normal mt-1 hidden">Please select one of the following options.</p>}
                </div>
                {props.supportAreas && <div className="queriesList mt-8 sm:mt-10 max-w-[90%] mx-auto sm:max-w-[80%]">
                    <div className="flex items-center gap-3 sm:gap-5 *:bg-[#717375] *:px-4 *:py-[6px] sm:*:py-[10px] *:rounded-lg *:text-white *:leading-4 *:sm:text-xl *:sm:leading-5 *:text-base leading-5 *:font-medium flex-wrap justify-center *:cursor-pointer">
                        {props.supportAreas.map((item, key) =>
                            <div className={props.isReasonOptionSelected ? props.issueReason === item ? 'selected' : 'hidden' : 'notSelected'} key={key} onClick={() => { handleCategorySelection(item) }} >{item}</div>
                        )}
                    </div>
                </div>}
            </div>
        </div>
    )
}

export default ReasonForContact;
